export default "/kiban/_next/static/images/03_2L_alm_core-27df411f6139ed7e3d89bc6cc3e4ad2f.png";